const _BACKOFFICE_ROUTES = [
  '/reports',
  '/reports/(.*)',
  '/abandoned-cart-report',
  '/admin/managebreed',
  '/admin-giftcard-transactions-report',
  '/AutoOrders',
  '/AutoOrders/(.*)',
  '/Cancellation-Report',
  '/commissions',
  '/Customer-History',
  '/Customer-List',
  '/customizedrecommendation',
  '/customizedrecommendation/(.*)',
  '/downline-orders',
  '/faststart-Report',
  '/formerPetpro-Report',
  '/funded-giftcard-transactions-report',
  '/giftcard-transactions-report',
  '/giftcards/managegiftcards',
  '/lead-generation-report',
  '/MVR-Caps-Report',
  '/organization/petprofilereport',
  '/pawtrip-report',
  '/Petpro-Report',
  '/petprofile/home',
  '/Product-Sales-Report',
  '/Prospect-List',
  '/Qualification-History-Report',
  '/randomizer',
  '/title-reports',
  '/tools',
  '/tools/(.*)',
  '/tree-viewer',
  '/volume-reports',
  '/volumes',
];

const _REPLICATED_ROUTES = [
  '/account-settings',
  '/auto-order/(.*)',
  '/dsa',
  '/enrollment',
  '/enrollment/(.*)',
  '/faq',
  '/faq/(.*)',
  '/ingredient-glossary',
  '/ingredient-glossary/(.*)',
  '/meet-the-team',
  '/meet-the-team/(.*)',
  '/myrecommendation',
  '/myrecommendation/(.*)',
  '/pages',
  '/pages/(.*)',
  '/paw-club',
  '/pawtree-story',
  '/pet-profile-creation-new',
  '/pet-profile-creation-new/(.*)',
  '/petprofile',
  '/petprofile/(?!home)(.*)',
  '/product-videos',
  '/product-videos/(.*)',
  '/trypawtree',
  '/trypawtree/(.*)',
  '/veterinary-advisory-council',
  '/veterinary-advisory-council/(.*)',
  '/why-pawtree',
  '/why-pawtree/(.*)',
];

const _PRIVATE_ROUTES = [
  '/checkout/preorder(.*)',
  '/thank-you(.*)',
  '/enrollment/packs',
  // Protected account routes (exclude login, findapetpro, forgotpassword)
  '/account/settings(.*)',
  '/account/profile(.*)',
  '/account/orders(.*)',
  '/account/addresses(.*)',
  '/account/paymentmethods(.*)',
  '/account/paw-points(.*)',
  '/account/avatar(.*)',
  '/account/earnings-account(.*)',
  '/account/notifications(.*)',
  '/account/privacypreference(.*)',
  '/auto-order/(.*)',
  '/AutoOrders/(.*)',
  '/giftcards/(.*)',
  '/orders(.*)',
  '/(?!login)(.*)',
  '/(?!forgotpassword)(.*)',
  '/(?!logout)(.*)',
];

const _AUTHENTICATION_ROUTES = ['/login(.*)', '/account/login(.*)', '/forgotpassword(.*)'];
export const AUTHENTICATION_ROUTES = [
  ..._AUTHENTICATION_ROUTES,
  ..._AUTHENTICATION_ROUTES.map(route => `/(.*)${route}`),
];

export const BACKOFFICE_ROUTES = [..._BACKOFFICE_ROUTES, ..._BACKOFFICE_ROUTES.map(route => `/(.*)${route}`)];
export const REPLICATED_ROUTES = [..._REPLICATED_ROUTES, ..._REPLICATED_ROUTES.map(route => `/(.*)${route}`)];

export const PRIVATE_ROUTES = [
  ..._PRIVATE_ROUTES,
  ..._PRIVATE_ROUTES.map(route => `/(.*)${route}`),
  ...BACKOFFICE_ROUTES,
];

const ROUTES_MAP = {
  BACKOFFICE_ROUTES,
  REPLICATED_ROUTES,
};

export default ROUTES_MAP;
